import React, { Component } from 'react'
import "./Cert.scss"

export default class Cert extends Component {
    render() {
        const imgFile = `../imgs/cert${this.props.index}.PNG`
        return (
            <>
                <img src={imgFile} alt={`${this.props.name} Certification`} className="Cert" />
                <h6>{this.props.name}</h6>
            </>
        )
    }
}
